// extracted by css-extract-rspack-plugin
export default {"optionsButtonContainer":"OptionsButton-module__optionsButtonContainer__QA_kZ","notificationIndicator":"OptionsButton-module__notificationIndicator__Wcnt0"};